<template>
  <form ref="form" method="post" :action="pay_u.getaway" v-on:submit.prevent>
    <input name="merchantId" type="hidden" :value="pay_u.api_key" />
    <input name="description" type="hidden" :value="description" />
    <input name="referenceCode" type="hidden" ref="referenceCode" />
    <input
      name="amount"
      type="hidden"
      :value="amount / 1000 <= 1 ? (amount = amount * 1000) : amount"
    />
    <input name="tax" type="hidden" value="0" />
    <input name="taxReturnBase" type="hidden" value="0" />
    <input name="signature" type="hidden" ref="signature" />
    <input name="accountId" type="hidden" :value="pay_u.account_id" />
    <input name="currency" type="hidden" :value="pay_u.currency" />
    <input name="test" type="hidden" value="1" />

    <input
      name="buyerFullName"
      type="hidden"
      :value="formName && formName != '' ? formName : kProfileFull.name"
    />
    <input
      v-if="!isCash"
      name="buyerEmail"
      type="hidden"
      :value="
        formEmail && formEmail != '' ? formEmail : 'sara@lvrpublicidad.com'
      "
    />
    <input name="mobilePhone" type="hidden" :value="user.username" />

    <input name="responseUrl" type="hidden" :value="pay_u.redirectUrl" />
    <input
      name="confirmationUrl"
      type="hidden"
      :value="isRecharge ? pay_u.notifyUrlRecharge : pay_u.notifyUrl"
    />

    <button :class="buttonClass" @click="onSubmitPayment()">
      {{ buttonLabel }}
    </button>
  </form>
</template>
<script>
import settings from "../../api/settings"
import plansApi from "../../api/plans"
import { mapGetters } from "vuex"
export default {
  props: [
    "selectedPlan",
    "isRecharge",
    "buttonLabel",
    "buttonClass",
    "formName",
    "formEmail",
    "isCash",
  ],
  data() {
    return {
      //DEV MODE ON
      pay_u: settings.pay_u_Dev,
      description: "panel testing",

      //amount: this.selectedPlan.price,

      /* name: "Juan Vargas",
      email: "juan_vargas10@hotmail.com", */
    }
  },
  methods: {
    onSubmitPayment() {
      if (!this.isRecharge) {
        plansApi
          .payUPaymentRequest(
            this.user.kProfile,
            this.selectedPlan._id,
            //discount it'll change=
            1,
            this.selectedPlan.price,
            "payu"
          )
          .then(apiResponse => {
            console.log(apiResponse, "Api PAgo Plan", this.$refs)
            const { payment, signature, referenceCode } = apiResponse

            //this.$refs["form"].action = this.pay_u.getaway

            this.$refs["referenceCode"].value = referenceCode
            this.$refs["signature"].value = signature
            console.log(payment, "apiResponse")
            setTimeout(() => {
              console.log("settimpoe", this.$refs["form"].action)
              this.$refs["form"].submit()
            }, 500)
          })
      } else {
        console.log(
          this.user.id,
          this.selectedPlan.promo_on_credits,
          this.selectedPlan.price,
          "Recargaaaaaa"
        )
        plansApi
          .payURechargeRequest(
            this.user.id,
            this.selectedPlan.promo_on_credits,
            this.selectedPlan.price,
            "payu"
          )
          .then(apiResponse => {
            console.log(apiResponse, "apiResponse", this)
            const { payment, signature, referenceCode } = apiResponse

            //this.$refs["form"].action = this.pay_u.getaway

            this.$refs["referenceCode"].value = referenceCode
            this.$refs["signature"].value = signature
            console.log(payment, "apiResponse")
            setTimeout(() => {
              console.log("settimpoe", this.$refs["form"].action)
              this.$refs["form"].submit()
            }, 500)
          })
      }
    },
  },
  computed: {
    ...mapGetters(["user"]),
    amount() {
      return this.selectedPlan.price
    },
    kProfileFull() {
      return this.user.profiles.find(pro => {
        return pro._id == this.user.kProfile
      })
    },
  },
}
</script>
